import React from 'react'
import { Space, Typography, Tag } from 'antd'
import { MedicineBoxOutlined, UserOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { getScheduleTime } from '../utils/formatters'

const { Text, Title } = Typography

const NextProcedure = ({ theatre }) => {
  if (!theatre.nextProcedure) return null

  return (
    <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
      <Title level={5} style={{ marginTop: 0 }}>
        Next Scheduled Procedure
      </Title>
      <div style={{ marginBottom: '8px' }}>
        <Space>
          <MedicineBoxOutlined />
          <Text>{theatre.nextProcedure}</Text>
        </Space>
      </div>
      <div style={{ marginBottom: '8px' }}>
        <Space>
          <UserOutlined />
          <Text>Patient: </Text>
          <Text strong>{theatre.nextPatient}</Text>
          <Tag color='blue'>{theatre.nextPatientId}</Tag>
        </Space>
      </div>
      <div>
        <Space>
          <ClockCircleOutlined />
          <Text>Scheduled: </Text>
          <Text strong>{getScheduleTime(theatre.scheduledTime)}</Text>
        </Space>
      </div>
    </div>
  )
}

export default NextProcedure
